import { loaderCreator } from '@/vuex/plugins/loaderPlugin/_base'
import { CONSENT_TYPES, addToConsentCallbackStore } from '@/utils/cookieConsent'
import { loadCrazyEgg } from '@/utils/crazyEgg'

export default loaderCreator(() => {
  addToConsentCallbackStore(CONSENT_TYPES.ADVERTISEMENT, (hasConsent) => {
    if (!hasConsent) return
    loadCrazyEgg()
  })
})
